import { jarabotDevStore } from '../devStore';
import { JARABOT_EVENTS } from '../jarabotClient';
import { readBnplLimitsOfferMemory, saveBnplLimitsOfferContact } from './memory';
import { createBnplLimitsOfferPayload } from './payload';
import { selectBnplLimitsOffer } from './selection';
import type { JarabotLoginOfferEvaluator } from '../loginOffers/types';

const SCREEN_NAME = 'bnpl_limits_offer';

export const evaluateBnplLimitsOffer: JarabotLoginOfferEvaluator = async ({
	customerId,
	profile,
	selfCareUrl,
	now,
}) => {
	const memory = readBnplLimitsOfferMemory(customerId);
	jarabotDevStore.trackBnplLimitsMemory(memory);

	const products = selectBnplLimitsOffer(profile, memory, now);

	if (!products) return null;

	return {
		event: JARABOT_EVENTS.CUSTOMER_BNPL_LIMITS_OFFER,
		screenName: SCREEN_NAME,
		payload: createBnplLimitsOfferPayload({ products, selfCareUrl }),
		onSent: () => {
			const saved = saveBnplLimitsOfferContact(customerId, now);

			jarabotDevStore.trackBnplLimitsSent(products);
			jarabotDevStore.trackBnplLimitsMemory(saved);
		},
	};
};
